import PropTypes from 'prop-types';

import MarkdownWrapper from 'core/components/MarkdownWrapper';
import Texts from 'core/components/Texts';

import styles from './index.styl';


export default function TableMarkdown(block, { theme }) {
  const {
    attributes: {
      body,
      headline,
    },
  } = block;

  const {
    colors: {
      divider,
    },
  } = theme;

  return (
    <div className={styles.table}>
      <style jsx>{`
        .${styles.table}
          :global(th)
          :global(td)
            border-color ${divider}
      `}</style>
      {headline && (
        <Texts tag='h3' type='title3'>
          {headline}
        </Texts>
      )}
      <MarkdownWrapper>
        {body}
      </MarkdownWrapper>
    </div>
  );
}

TableMarkdown.propTypes = {
  /** Даннные о виджете */
  attributes: PropTypes.object,
};
